import { render, staticRenderFns } from "./EditImoveltipoPage.vue?vue&type=template&id=75f59682&"
import script from "./EditImoveltipoPage.vue?vue&type=script&lang=js&"
export * from "./EditImoveltipoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports